

import React, { useEffect } from "react";
import { setTzurPopup } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";
import "../../pages/Delivery/Menu/menu.scoped.scss"

const TzurPopup = () => {
    const { state, dispatch } = useStore();
    const { tzurPopup } = state;
    const { Title, isOpen, Component,closingAction } = tzurPopup;

    const resetScrollPosition = () => {
        document.body.style.overflow = "auto";
        // window.scrollTo({ top: (scrollTop || 0) + (document.querySelector(".popup_area")?.offsetHeight || 0) });
    }

    useEffect(() => {
        if (isOpen === false) {
            resetScrollPosition();
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    const close = (e, shouldCallClosingAction) => {

        e.preventDefault();
        shouldCallClosingAction && typeof (closingAction) === "function" && closingAction();
        resetScrollPosition();
        dispatch(setTzurPopup({ isOpen: false }));
    };

    return (
         <div className="sidePanel" id="newCategory" aria-hidden="false">
        <div className="sidePanel_frame active">
            <div className="sidePanel_close"><a onClick={close} href="javascript:void(0)" aria-label="חלונית קטגוריה חדשה - לחץ לסגירה" role="button" aria-controls="newCategory"><i role="img" aria-hidden="true" className="icon-close"></i></a></div>
            <div className="sidePanel_title"><h3>{Title}</h3></div>
            <div className="sidePanel_body">

                {Component}
                
            </div>
        </div>
    </div>
    );
}

export default TzurPopup;

export const openTzurPopup = (dispatch,Title,Component) => {
    const scrollTop = document.documentElement.scrollTop;

    dispatch(setTzurPopup({
        isOpen: true,
        Title,
        Component
    }));
};

